var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"slider-nav"},[_c('div',{staticClass:"slider-nav-bar"},[_c('div',{staticClass:"inner",style:({width: _vm.width + '%', 'margin-left': _vm.left + '%'})})])])}
var staticRenderFns = []

export { render, staticRenderFns }